export default {
  // Navigation
  'nav.home': 'Accueil',
  'nav.about': 'À propos',
  'nav.features': 'Fonctionnalités',
  'nav.partners': 'Partenaires',
  'nav.testimonials': 'Témoignages',
  'nav.login': 'Connexion',
  'nav.portal': 'Portail Membre',
  
  // Hero
  'hero.title': 'Apprendre. Gagner. Acheter. Échanger.',
  'hero.subtitle': 'Transformez votre parcours d\'apprentissage en récompenses avec HoneyMoneyUnits (HMU)',
  'hero.cta.primary': 'Commencer à Gagner des HMU',
  'hero.cta.secondary': 'En Savoir Plus',
  
  // Stats
  'stats.activeUsers': 'Utilisateurs Actifs',
  'stats.hmuEarned': 'HMU Gagnés',
  'stats.partners': 'Marques Partenaires',
  'stats.rewards': 'Récompenses Échangées',
  
  // Features
  'features.title': 'Comment Fonctionne HoneyJar',
  'features.learn.title': 'Apprendre',
  'features.learn.desc': 'Complétez des modules éducatifs et gagnez des HMU',
  'features.earn.title': 'Gagner',
  'features.earn.desc': 'Interagissez avec les marques partenaires et accumulez des points',
  'features.shop.title': 'Acheter',
  'features.shop.desc': 'Parcourez les marchandises exclusives et les offres partenaires',
  'features.redeem.title': 'Échanger',
  'features.redeem.desc': 'Échangez vos HMU contre des récompenses et des produits',
  'features.levelup.title': 'Monter de Niveau',
  'features.levelup.desc': 'Débloquez des badges, des séries et des avantages exclusifs',
  
  // Portal
  'portal.welcome': 'Bon retour',
  'portal.hmuBalance': 'Solde HMU',
  'portal.tierProgress': 'Progression de Niveau',
  'portal.currentStreak': 'Série Actuelle',
  'portal.badges': 'Badges Collectés',
  'portal.activeMissions': 'Missions Actives',
  'portal.partnerOffers': 'Offres Partenaires',
  'portal.recommendations': 'Recommandations Personnalisées',
  
  // Missions
  'missions.title': 'Missions',
  'missions.all': 'Toutes',
  'missions.learning': 'Apprentissage',
  'missions.affiliate': 'Affiliation',
  'missions.completed': 'Terminées',
  'missions.active': 'Missions Actives',
  'missions.completedCount': 'Terminées',
  'missions.earned': 'HMUs Gagnés',
  'missions.timeInvested': 'Temps Investi',
  'missions.start': 'Démarrer la Mission',
  'missions.continue': 'Continuer',
  'missions.completed.btn': 'Terminée',
  'missions.referralBonus': 'Bonus de Parrainage',
  'missions.streakBonus': 'Bonus de Série',
  
  // Rewards
  'rewards.title': 'Catalogue de Récompenses',
  'rewards.all': 'Toutes',
  'rewards.bewear': 'B.E. Wear',
  'rewards.digital': 'Produits Numériques',
  'rewards.partner': 'Offres Partenaires',
  'rewards.redeem': 'Échanger',
  'rewards.locked': 'Verrouillé',
  'rewards.earnCPV': 'Gagnez',
  'rewards.earnCCV': 'par conversion',
  'rewards.selectSize': 'Sélectionner la Taille',
  
  // Auth
  'auth.login': 'Connexion',
  'auth.register': 'S\'inscrire',
  'auth.email': 'Email',
  'auth.password': 'Mot de passe',
  'auth.name': 'Nom Complet',
  'auth.location': 'Localisation',
  'auth.referralCode': 'Code de Parrainage (Optionnel)',
  'auth.welcomeBonus': 'Obtenez 50 HMU de Bonus de Bienvenue!',
  'auth.optIn.tracking': 'J\'accepte le suivi d\'activité',
  'auth.optIn.notifications': 'Je veux recevoir des notifications',
  'auth.optIn.partnerOffers': 'Je veux recevoir des offres partenaires',
  'auth.noAccount': 'Vous n\'avez pas de compte?',
  'auth.hasAccount': 'Vous avez déjà un compte?',
  'auth.signUp': 'S\'inscrire',
  'auth.signIn': 'Se connecter',
  
  // Footer
  'footer.tagline': 'Autonomiser l\'apprentissage par les récompenses',
  'footer.company': 'Entreprise',
  'footer.about': 'À Propos',
  'footer.careers': 'Carrières',
  'footer.press': 'Presse',
  'footer.contact': 'Contact',
  'footer.resources': 'Ressources',
  'footer.blog': 'Blog',
  'footer.help': 'Centre d\'Aide',
  'footer.faq': 'FAQ',
  'footer.legal': 'Légal',
  'footer.privacy': 'Politique de Confidentialité',
  'footer.terms': 'Conditions d\'Utilisation',
  'footer.compliance': 'Conformité',
  'footer.rights': 'Tous droits réservés',
  'footer.owner': 'Bingham ENT Global Empire',
  
  // Common
  'common.currency': 'HMU',
  'common.days': 'jours',
  'common.hours': 'heures',
  'common.minutes': 'minutes',
  'common.loading': 'Chargement...',
  'common.error': 'Une erreur s\'est produite',
  'common.success': 'Succès!',
};